import React, { useMemo } from "react";
import { Grid, IconButton, useTheme } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { themeQuartz } from "@ag-grid-community/theming";
const DataTable = ({
    columnDefs,
    rowData,
    pagination = true,
    suppressRowTransform,
    wrapHeaderText = false,
    autoHeaderHeight = false,
}) => {
    const theme = useTheme();

    const AgGridTheme = themeQuartz.withParams({
        accentColor: theme.palette.background.paper,
        // rowHoverColor: theme.palette.common.agGrid.rowHover,
        backgroundColor: "#fbfdfe",
        borderRadius: "4px",
        browserColorScheme: "light",
        cellHorizontalPaddingScale: 1,
        columnBorder: false,
        fontSize: "14px",
        foregroundColor: theme.palette.text.primary,
        headerBackgroundColor: theme.palette.primary.main,
        headerFontFamily: "inherit",
        headerFontSize: "12px",
        headerTextColor: theme.palette.common.white,
        headerVerticalPaddingScale: 1,
        rowVerticalPaddingScale: 1,
        spacing: "8px",
        wrapperBorderRadius: "10px",
        borderColor: "#d1d1d1",
    });

    const onSortChanged = (e) => {
        e.api.refreshCells({ force: true });
    };

    const defaultColDef = useMemo(() => {
        return {
            filter: true,
            flex: 1,
            wrapHeaderText: wrapHeaderText,
            autoHeaderHeight: autoHeaderHeight,
            wrapText: wrapHeaderText,
            autoHeight: autoHeaderHeight,
        };
    }, []);

    return (
        <Grid xs={12} padding={2} sx={{ height: "100vh" }}>
            <AgGridReact
                theme={AgGridTheme}
                loadThemeGoogleFonts
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                rowData={rowData}
                gridOptions={{
                    pagination: pagination,
                    paginationPageSize: 100,
                    paginationPageSizeSelector: [100, 200, 500],
                }}
            />
        </Grid>
    );
};

export default DataTable;
